// extracted by mini-css-extract-plugin
export var completionBody = "_mm-2";
export var completionCard = "_mm-0";
export var completionFooter = "_mm-3";
export var completionTitle = "_mm-1";